const sectionCode = "SPRO2";
const chartCode = "C035x";

import { Procedures } from "modules/provider/shared/procedure-charts";

function T35Procedures() {
  return <Procedures chartCode={chartCode} sectionCode={sectionCode} />;
}

export { T35Procedures };
